export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_SAVE_SHIPPING = 'CART_SAVE_SHIPPING';
export const CART_SAVE_PAYMENT = 'CART_SAVE_PAYMENT';
export const CART_SAVE_REMARK = 'CART_SAVE_REMARK';
export const CART_SAVE_TIME = 'CART_SAVE_TIME';
export const CART_SAVE_COUPON = 'CART_SAVE_COUPON';
export const CART_SAVE_ANONYMOUS = 'CART_SAVE_ANONYMOUS';